// Shared manager for react-datepicker instances used inside the registration grid.
//
// Goals:
// - Ensure ONLY ONE datepicker can be open at any time (prevents stacking).
// - Provide a stable per-object identity without mutating MobX objects.
// - Allow grid navigation to force-close any open datepicker before moving focus.
//
// NOTE: This is intentionally tiny and framework-agnostic. Callers provide close/open/focus.
let _activeKey = null;
const _instances = new Map(); // key -> { close, open, focus }

const _objectIds = new WeakMap();
let _nextObjectId = 1;

export function objectIdentity(obj) {
  if (!obj || (typeof obj !== "object" && typeof obj !== "function")) return String(obj);
  let id = _objectIds.get(obj);
  if (!id) {
    id = String(_nextObjectId++);
    _objectIds.set(obj, id);
  }
  return id;
}

export function registerDatePicker(key, handlers) {
  _instances.set(key, handlers);
}

export function unregisterDatePicker(key) {
  _instances.delete(key);
  if (_activeKey === key) _activeKey = null;
}

export function getActiveKey() {
  return _activeKey;
}

export function closeActive() {
  if (!_activeKey) return;
  const inst = _instances.get(_activeKey);
  if (inst && inst.close) inst.close();
  _activeKey = null;
}

export function requestOpen(key) {
  if (!key) return;
  if (_activeKey && _activeKey !== key) {
    const prev = _instances.get(_activeKey);
    if (prev && prev.close) prev.close();
  }
  const inst = _instances.get(key);
  if (inst && inst.open) inst.open();
  _activeKey = key;
}

export function requestClose(key) {
  if (!key) return;
  const inst = _instances.get(key);
  if (inst && inst.close) inst.close();
  if (_activeKey === key) _activeKey = null;
}

export function requestFocus(key) {
  if (!key) return;
  const inst = _instances.get(key);
  if (inst && inst.focus) inst.focus();
}


